import { Link } from "react-router-dom";
import SVG from "../../SVG";
export default function Container({
  color = "",
  pnl = false,
  days = false,
  width,
  className = "",
  title = "",
  value = "-",
  link,
  hrefLink,
  data = "",
  button,
  buttonText,
  hrefButton,
  svgName = "",
  svgClassName = "",
}) {
  const colorMap = {
    green: {
      light: "#C9DFB9",
      dark: "#224A2A",
    },
    yellow: {
      light: "#FFDD83",
      dark: "#594417",
    },
    red: {
      light: "#E5D1D1",
      dark: "#7A1919",
    },
    blue: {
      light: "#D1DBE5",
      dark: "#194A7A",
    },
  };

  // PNL auto-coloring + icon switching
  if (pnl) {
    const num =
      typeof value === "string"
        ? parseFloat(value.replace(/[^0-9.-]/g, ""))
        : Number(value);

    if (!isNaN(num)) {
      if (num >= 0) {
        color = "green";
        svgName = "pnl";
      } else {
        color = "red";
        svgName = "pnlloss";
      }
    }
  }

  const selected = colorMap[color] || colorMap.green;

  const maxValue = 150;
  const numericValue = (() => {
    if (typeof value === "number") return value;
    if (typeof value === "string") {
      const parsed = parseFloat(value.replace(/[^0-9.]/g, ""));
      return isNaN(parsed) ? 0 : parsed;
    }
    return 0;
  })();
  const fillRatio = Math.max(0, Math.min(1, numericValue / maxValue));

  const handleCopy = () => {
    if (value === undefined || value === null) return;
    if (
      typeof navigator !== "undefined" &&
      navigator.clipboard &&
      navigator.clipboard.writeText
    ) {
      navigator.clipboard.writeText(String(value)).catch((err) => {
        console.error("Failed to copy:", err);
      });
    }
  };

  const style = { "--shape-bg": selected.light, "--shape-width": width };
  return (
    <div className="size-fit relative">
      <div
        className="rounded-[1000px] absolute top-0 right-0 flex justify-center items-center"
        style={{
          width: `calc(${width} / 7.5)`,
          height: `calc(${width} / 7.5)`,
          background: selected.dark,
        }}
      >
        <SVG
          name={svgName}
          classname={svgClassName}
          style={{ width: `calc(${width} / 15)` }}
        />
      </div>

      <div
        className={`zi-shape-information-card-container relative ${className}`}
        style={style}
      >
        <h3
          className="absolute text-sm font-normal right-0 top-0"
          style={{
            color: selected.dark,
            right: `calc(${width} / 5)`,
            top: `calc(${width} / 20)`,
          }}
        >
          {title}
        </h3>
        <div
          className="flex gap-4 items-center absolute left-0 bottom-0"
          style={{ left: `calc(${width} / 20)`, bottom: `calc(${width} / 20)` }}
        >
          {link && (
            <Link to={hrefLink}>
              <SVG
                name="link"
                style={{ stroke: selected.dark, width: `calc(${width} / 15)` }}
              />
            </Link>
          )}
          <p
            className="text-4xl font-normal"
            style={{
              color: selected.dark,
              direction: pnl ? "ltr" : "inherit",
            }}
          >
            <bdi dir="ltr">{value}</bdi>
            {days && value !== "-" && (
              <span className="text-sm" style={{ color: selected.dark + "80" }}>
                روز
              </span>
            )}
          </p>
        </div>

        <div
          className="absolute bottom-0 right-0"
          style={{
            right: `calc(${width} / 20)`,
            bottom: `calc(${width} / 15)`,
          }}
        >
          {data === "copy" && (
            <button
              type="button"
              onClick={handleCopy}
              className="flex items-center justify-center gap-1 rounded-lg py-1 px-2"
              style={{ backgroundColor: selected.dark + "26" }}
            >
              <SVG
                name="copy"
                classname="opacity-50"
                style={{ stroke: selected.dark }}
              />
              <span
                className="font-normal text-xs opacity-50"
                style={{ color: selected.dark }}
              >
                کپی کردن
              </span>
            </button>
          )}
          {data === "minimum" && (
            <div className="flex flex-col items-center justify-center gap-0.5">
              <svg viewBox="0 0 100 50" width="50" height="25">
                {/* background arc */}
                <path
                  d="M10 50 A40 40 0 0 1 90 50"
                  fill="none"
                  stroke={selected.dark + "26"}
                  strokeWidth="12.5"
                  pathLength="100"
                />
                {/* value arc */}
                <path
                  d="M10 50 A40 40 0 0 1 90 50"
                  fill="none"
                  stroke={selected.dark + "80"}
                  strokeWidth="12.5"
                  // strokeLinecap="round"
                  pathLength="100"
                  strokeDasharray="100"
                  strokeDashoffset={100 - fillRatio * 100}
                />
              </svg>
              <span
                className="font-light text-xs opacity-50"
                style={{ color: selected.dark }}
              >
                MIN 150 USDT
              </span>
            </div>
          )}
        </div>
      </div>

      {button && (
        <Link
          to={hrefButton}
          className="w-full flex justify-center items-center rounded-[1000px] py-2.5 mt-2.5"
          style={{ background: selected.dark }}
        >
          <span className="text-sm font-normal text-white">{buttonText}</span>
        </Link>
      )}
    </div>
  );
}
